import { hooks_default } from './chunk-Z3RTBJ5E.mjs';
import { slugify, compareString } from './chunk-USSHZLWS.mjs';

// src/universal/index.ts
var commonHelpers = {
  compareString,
  slugify
};
var requestHelpers = {
  // callable,
};
var universal_default = hooks_default;

export { commonHelpers, requestHelpers, universal_default };
//# sourceMappingURL=chunk-EQUBQDYT.mjs.map
//# sourceMappingURL=chunk-EQUBQDYT.mjs.map